// src/icons/BitcoinBOnRoundedSquare.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function BitcoinBOnRoundedSquare() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "16", height: "16", rx: "2", fill: "#F7931A" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6.02512 4.51426H4.66602M6.02512 4.51426V7.88244M6.02512 4.51426H6.55219M6.02512 7.88244H9.33688M6.02512 7.88244V11.2506M9.33688 7.88244C10.5433 7.88244 11.2676 8.63643 11.2676 9.56653C11.2676 10.4966 10.5433 11.2506 9.33688 11.2506M9.33688 7.88244C10.5433 7.88244 11.2676 7.12845 11.2676 6.19835C11.2676 5.26826 10.5433 4.51426 9.33688 4.51426M9.33688 11.2506V12.8337M9.33688 11.2506H6.55219M6.02512 11.2506H4.66602M6.02512 11.2506H6.55219M9.33688 4.51426V3.16699M9.33688 4.51426H6.55219M6.55219 3.16699V4.51426M6.55219 11.2506V12.8337",
            stroke: "white",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}

export {
  BitcoinBOnRoundedSquare
};
